/**
 * 权限控制组件导出
 */

export { default as PermissionButton } from './Button';
export { default as TextButton } from './TextButton';
export type { PermissionButtonProps } from './Button';

